import { getCookie, getCookieUser, getObjectCookie } from '../utils/cookieFn';
import { getBrowserIdFromCanvas } from '../utils/getBrowserIdFromCanvas';
import { getStringRandom } from '../utils/getStringRandom';
import { getTraceId } from '../utils/getTraceid';

// 不可以直接改这里来调试
const STAT_CONFIG_BASE_URL_EU = typeof process !== 'undefined' ? process?.env?.NEXT_PUBLIC_BH_HOST : 'https://api-burying-point.ecoflow.com';
const STAT_CONFIG_BASE_URL_NA = typeof process !== 'undefined' ? process?.env?.NEXT_PUBLIC_BH_HOST_NA : 'https://api-burying-point-us.ecoflow.com';

export const STAT_CONFIG_IS_OPEN_GTM = true;
export const device_id_key = 'ef_device_id_09'; // 设备ID-key
export const package_id_key = 'ef_package_id_05'; // 访问ID-key
export const from_page_id_key = 'ef_from_page_id_01'; // 来源页面ID
export const from_pathname_key = 'ef_from_pathname_01'; // 来源页面路径
export const oneIntervalTimeA = 20; //多少秒自动发送一次
export const maxIntervalTotal = 90; //最多发送多少数就停止自动倒计发送,执行页面刷新发送
export const maxDurationNumber = 30 * 60; //最多停留30分钟;
export const data_center_eu = ['de', 'it', 'uk', 'fr', 'cis', 'es', 'eu', 'za', 'sa', 'jp', 'kr']; //欧州数据中心
export const getStatInterfaceObj = (locale: string, project: string) => {
    const project_array = ['ecoflow', 'home', 'forum', 'shopify-na', 'shopify-eu', 'shopify-jp', 'shopify-other'];
    const isInProjectA = project_array.includes(project);
    const projectB = isInProjectA ? project : 'shopify-other'; //如果传入的值不在里面,使用shopify-other
    const projectC = projectB === 'ecoflow' ? 'gtm1' : projectB; // ecoflow 是使用 gtm1
    const STAT_CONFIG_BASE_URL_2 = data_center_eu.includes(locale) ? STAT_CONFIG_BASE_URL_EU : STAT_CONFIG_BASE_URL_NA;

    return {
        createVisitorUrl: `${STAT_CONFIG_BASE_URL_2}/gtm1/visitor/web/create`, //创建用户
        createPackageUrl: `${STAT_CONFIG_BASE_URL_2}/gtm1/visitor/web/create-package`, //创建访问用户
        updatePackageUrl: `${STAT_CONFIG_BASE_URL_2}/gtm1/visitor/web/update-package`, //更新访问

        baseUrlGa4: `${STAT_CONFIG_BASE_URL_2}/${projectC}/events-m2/web/create`, //主动型事件-GA4
        baseUrlPageModuleCreate: `${STAT_CONFIG_BASE_URL_2}/${projectC}/events-m1/web/create`, //主动型事件-自有-创建
        baseUrlPageModuleUpdate: `${STAT_CONFIG_BASE_URL_2}/${projectC}/events-m1/web/update`, //主动型事件-自有-更新
        createVisitTimeUrl: `${STAT_CONFIG_BASE_URL_2}/${projectC}/pages/web/create`, //创建页面路径事件
        updateVisitTimeUrl: `${STAT_CONFIG_BASE_URL_2}/${projectC}/pages/web/update`, //更新页面路径结束时间
    };
};

// 获取设备ID
export const StatGetDeviceId = async ({ textIdA1 = '' }: { textIdA1?: string }) => {
    const device_id_key_old = 'ef_device_id_08';
    const device_id_cookie_old = getCookie(device_id_key_old); // cookie的 device_id,用于不同域名共用
    const device_id_cookie_new = getCookie(device_id_key); // cookie的 device_id,用于不同域名共用
    const device_id_cookie = device_id_cookie_new || device_id_cookie_old;
    const device_id_storage = localStorage.getItem(device_id_key); //将cookie下的 device_id转到 storage
    let device_id = device_id_cookie || device_id_storage;
    // 2个id都不存在,生成一个新的id
    if (!device_id) {
        device_id = await getBrowserIdFromCanvas({
            textIdA1,
        });
    }
    // 设置 cookie 的 device_id
    if (!device_id_cookie_new && device_id) {
        document.cookie = `${device_id_key}=${device_id}; domain=.ecoflow.com; path=/;`;
        document.cookie = `${device_id_key_old}=${device_id}; domain=.ecoflow.com; path=/;`;
    }
    // 设置 localStorage 的 device_id
    if (!device_id_cookie_new && device_id) {
        localStorage.setItem(device_id_key, device_id);
        localStorage.setItem(device_id_key_old, device_id);
    }

    return device_id;
};
export const getGaSessionId = () => {
    const cookieObjectA = getObjectCookie();
    const gaIdArrayA = []; // 具体的cookie; 值如:GS2.1.s1749195668$o2$g1$t1749195726$j2$l0$h0
    const gaIdArrayB = []; // 具体的数字;值如:1749195668
    for (const keyA in cookieObjectA) {
        if (!keyA.includes('_ga_')) {
            continue;
        }
        gaIdArrayA.push(cookieObjectA[keyA]);
    }
    for (let i = 0; i < gaIdArrayA.length; i++) {
        const valueA = gaIdArrayA[i];
        if (!valueA) {
            continue;
        }
        const valueB = valueA.slice(7, 17);
        const valueC = Number(valueB);
        if (!valueC) {
            continue;
        }
        gaIdArrayB.push(valueC);
    }
    if (gaIdArrayB.length) {
        return Math.max(...gaIdArrayB);
    }

    return '';
};
// 获取访问ID
export const StatGetPackageId = () => {
    let package_id = localStorage.getItem(package_id_key);
    if (!package_id) {
        package_id = getTraceId(32);
        localStorage.setItem(package_id_key, package_id);
    }

    return package_id;
};
// 获取用户ID
export const StatGetUserId = () => {
    const info: any = getCookieUser() || {};

    return info?.user?.userId || '';
};

// 获取页面ID
export const StatGetPageId = (package_id: string) => {
    if (!package_id) {
        return '';
    }
    const string1 = getStringRandom(15); //随机字符串
    const page_id_2 = `${package_id}_${string1}`;
    return page_id_2;
};

// 来源页面ID-获取
export const StatGetFromPageId = () => {
    return localStorage.getItem(from_page_id_key) || '';
};
// 来源页面ID-设置
export const StatSetFromPageId = (page_id: string) => {
    return localStorage.setItem(from_page_id_key, page_id);
};

// 来源页面路径-获取
export const StatGetFromPathname = () => {
    return localStorage.getItem(from_pathname_key) || '';
};
// 来源页面路径-设置
export const StatSetFromPathname = (pathname: string) => {
    return localStorage.setItem(from_pathname_key, pathname);
};

export const DefaultProject = 'ecoflow'; // ecoflow:品牌官网 shopify:shopify商城 homebattery:家储官网

// 获取会话ID
export const getSessionIdA = () => {
    const timesA1 = `${Date.now()}`;
    const timesA2 = timesA1.slice(0, 10);

    const valueA1 = `${Math.random()}`.slice(2);
    const valueA2 = `${Math.random()}`.slice(2);
    const valueA3 = `${Math.random()}`.slice(2);
    const valueA4 = `${Math.random()}`.slice(2);
    const valueA5 = `${Math.random()}`.slice(2);
    const valueA6 = `${Math.random()}`.slice(2);
    const valueA7 = `${Math.random()}`.slice(2);
    const valueA8 = `${Math.random()}`.slice(2);
    const valueA9 = `${Math.random()}`.slice(2);
    const valueB1 = `${valueA1}${valueA2}${valueA3}`.slice(0, 8);
    const valueB2 = `${valueA4}${valueA5}${valueA6}`.slice(0, 8);
    const valueB3 = `${valueA7}${valueA8}${valueA9}`.slice(0, 6);
    const timesB1 = timesA2.slice(0, 5);
    const timesB2 = timesA2.slice(5);

    const valueC = `${valueB1}${timesB1}${valueB2}${timesB2}${valueB3}`;
    return valueC;
};

const closeWebpDataBase64 =
    'data:image/webp;base64,UklGRhIDAABXRUJQVlA4WAoAAAAQAAAAxwAAxwAAQUxQSJoBAAABJyAQSOFmFxERA+zItts2UCiAJTigAKcCFNB/UxLx3rv3wL+K6L8Dt5EUqRZ8fLW8b2hLDC//8w9kW6Hp1xhHfNNtjDGOhqYHbS6PdG1uj5zVTeW8PRX902YMObfnpuo8o1X+xjZ2KLXM9ui05L5HbRf/0AShhh/a9ukqE/umuq7G3HNtX7U2tPrQakSpE6VWdHrRaUalG5V2NPrRCEAhAYUI6jKoC6EqhaoYanKoCaIiiYoo8rLICyMrjaw4cvLICSQjkYxIYpnEQomkEollLpe5XKaCmUokIZKETEKhhFIJxBLIZeYaWeMJ2glkp4CdwjUAawDVEKgxi1zj17hXWeSea4l7R7BzuM7BGkE1AmoM0xikGYhmAJqDZw6cWWhmgZmHZR6UFUhWAFmDYw2MVShWgViHYR2ECggqAKjBrwa7KtyqMKvDqw6rSpwqsSleEQdtLuLV/rbP2fO8q2v+aTPde8RY0vXr+6DMpj8I3oyz3poQR+77Y1lNF/+QoenN8EPb7kiWc2jyqqeGb9raoTmaLjG8/M/6aVZQOCBSAQAA8BcAnQEqyADIAD6RQJ5JpaOjISkfSFiwEglpbuFqUPEzq/AH8A/AD8AP397/BPvO7u7u7u7u7u7u7u7miEfxrE6zlqiLE/H9gBXWiXL7ulo6UFDYWcTrFXM9EUM88sH23gfiVcxYvIqmTidYspWn6sSemop+SN4393jb07et9SuE/HIhGYPXE+WovE40zcnc0QjMK2NKC/PV+vp9M9s0DsyW0qITkPxKrViVtGnEqi8gUOQH6bF0MmySdFFnSSawksUoFwn44AAA/v1JCodMAsIszuFjeEJP69sI4dR5/fjrornvyNxMM4Qg9A67bvtcKxvGSn3Bok4GEBSoQhBLisXtaqoozlDdoptkEewhzsVHXI1Pb9JdJ4/mH2ZBLHzqiSHy/t32uFY0mP8o4hJMRkL4z3nuSDx1J4mXPB3/k4Ud4kvD9ap6NtgYQAAAAAAAAAA=';
// 判断浏览器是否支持 webp
export const checkSupportWebp_createImageBitmap = async () => {
    try {
        if (!window.createImageBitmap) return Promise.resolve(false);
        const webpData = closeWebpDataBase64;
        return fetch(webpData)
            .then((r) => r.blob())
            .then((blob) =>
                createImageBitmap(blob).then(
                    () => true,
                    () => false,
                ),
            )
            .catch(() => false);
    } catch (e) {
        return Promise.resolve(false);
    }
};

// 判断浏览器是否支持 webp
export const checkSupportWebp_img = async () => {
    try {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = closeWebpDataBase64;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
        });
    } catch (e) {
        return Promise.resolve(false);
    }
};

// 判断浏览器是否支持 webp;唉,这该死的兼容问题,为啥会有一半以为不兼容
export const checkSupportWebp = async () => {
    const flagA2 = await checkSupportWebp_createImageBitmap();
    if (flagA2) {
        return true;
    }
    const flagA3 = await checkSupportWebp_img();
    if (flagA3) {
        return true;
    }
    return false;
};

// 判断浏览器是否支持 css 容器多媒体查询,用于后续的商城
export const checkSupportContainerQueriesA1 = () => {
    try {
        // 检测是否支持container-type属性
        const flagA1 =
            CSS.supports('container-type', 'inline-size') ||
            // 检测是否支持简写的container属性
            CSS.supports('container', 'inline-size');
        return flagA1;
    } catch (error) {
        return false;
    }
};
export const checkSupportContainerQueriesA2 = () => {
    try {
        // 创建一个临时样式表
        const style = document.createElement('style');
        document.head.appendChild(style);

        // 尝试插入容器查询规则
        const sheetA = style.sheet;
        if (!sheetA) {
            return false;
        }
        sheetA.insertRule('@container (min-width: 1px) {}', 0);

        // 如果成功插入，则支持容器查询
        const supports = true;

        // 清理临时元素
        document.head.removeChild(style);
        return supports;
    } catch (e) {
        // 插入失败，不支持容器查询
        return false;
    }
};
export const checkSupportContainerQueries = () => {
    const flagA1 = checkSupportContainerQueriesA1();
    if (flagA1) {
        return true;
    }
    const flagA2 = checkSupportContainerQueriesA2();
    if (flagA2) {
        return true;
    }

    return false;
};
